import { abortable as abortableBase, cleanPath, replaceDoubleSlashWithSingleSlash, } from "@enfusion-ui/utils";
import queryString from "query-string";
import DOCUMENTS_API from "./documents";
const REPORT = "report";
export default (restServer) => {
    const abortable = (c) => abortableBase(restServer, c);
    const documentsAPI = DOCUMENTS_API(restServer);
    return {
        // GET /internal/api/reports/query?report={path}
        // type        | name   | value        | required | default |
        // query param | report | string       | required | null    |
        GET_ROOT_NODE_FACTORY: () => documentsAPI.GET_ROOT_NODE_FACTORY(REPORT),
        GET_SAVED_QUERY: (path) => {
            const report = cleanPath(path);
            let url = "/internal/api/reports/query";
            const fixedReport = report?.startsWith("fixed/");
            if (fixedReport) {
                url = `${url}${report?.replace("fixed", "")}`;
            }
            return restServer(queryString.stringifyUrl({
                url,
                query: fixedReport ? {} : { report },
            }));
        },
        // GET /internal/api/reports/query/default?report={path}
        // type        | name      | value             | required | default |
        // query param | queryType | REPORT_QUERY_TYPE | required | null    |
        GET_DEFAULT_QUERY: (queryType) => restServer(queryString.stringifyUrl({
            url: "/internal/api/reports/query/default",
            query: { queryType },
        })),
        GET_GROUPING_TEMPLATES: abortable((reportType) => queryString.stringifyUrl({
            url: "/internal/api/reports/query/groupingtemplates",
            query: { reportType },
        })),
        GET_GROUPING_TEMPLATES_PATH: (reportType) => queryString.stringifyUrl({
            url: "/internal/api/reports/query/groupingtemplates",
            query: { reportType },
        }),
        GET_LEDGER: () => restServer("/internal/api/gl/v1/ledgers/all"),
        GET_LEDGERS_PATH: () => "/internal/api/gl/v1/ledgers/all",
        GET_MARKET_ENV_PATH: () => "/internal/api/legalentity/v1/marketenvironments",
        GET_PORTFOLIO_GROUPS: () => restServer("/internal/api/legalentity/v1/portfoliogroups"),
        GET_PORTFOLIO_GROUPS_PATH: () => "/internal/api/legalentity/v1/portfoliogroups",
        GET_QUOTE_SETS_PATH: () => "/internal/api/legalentity/v1/quotesets",
        GET_SOURCES_PATH: () => "/internal/api/legalentity/v1/marketdata/sources",
        STORE_REPORT: ({ path, subRoot, reportQuery, forceWrite = false }) => restServer(`/internal/api/documents/reports/${subRoot}`, {
            body: {
                path: replaceDoubleSlashWithSingleSlash(`/${path}/`),
                forceWrite,
                reportQuery,
            },
        }),
        CREATE_FOLDER: (root, filePath) => documentsAPI.CREATE_FOLDER(REPORT, `${root}/${filePath}`),
        RENAME_FOLDER: (filePath, newFolderName) => documentsAPI.RENAME_FOLDER(REPORT, filePath, newFolderName),
        DELETE_ENTRY: (filePath) => documentsAPI.DELETE_ENTRY(REPORT, filePath),
        MOVE_ENTRY: (filePath, destinationFolder, forceWrite) => documentsAPI.MOVE_ENTRY(REPORT, filePath, destinationFolder, forceWrite),
    };
};
